<template>
  <article :class="postClasses">
    <a class="entry-link" :href="postUrl">
      <div class="row">
        <div class="col-xs-12 col-sm-4 col-md-3">
          <img class="entry-thumbnail" v-if="thumbnailUrl()" :src="thumbnailUrl()">
        </div>
        <div class="col-xs-12 col-sm-8 col-md-9">
          <header class="entry-header">
            <div class="entry-meta">
              <div class="entry-post-type">
                {{ postType }}
              </div>
              <div class="entry-date" v-if="post.type !== 'etablissement'">
                {{ date }}
              </div>
            </div>
            <h3 class="entry-title" v-html="post.title.rendered"></h3>
          </header>
          <div class="entry-resume" v-html="resume()">
          </div>
        </div>
      </div>
    </a>
    <footer class="entry-footer">
      <div class="post-tags">
        <a v-for="tag in tags"
           :href="'/?s=' + tag.name"
           class="btn btn-xs btn-default">{{ tag.name }}</a>
        <div class="social-links">
          <a class="icon-social-link" :href="facebookShareUrl">
            <i class="icon-social icon-pictos_site_OIP_facebook"></i>
          </a>
          <a class="icon-social-link" :href="twitterShareUrl">
            <i class="icon-social icon-pictos_site_OIP_twitter"></i>
          </a>
          <a class="icon-social-link" :href="emailShareUrl">
            <i class="icon-social icon-pictos_site_OIP_contacter"></i>
          </a>
        </div>
      </div>
    </footer>
  </article>
</template>

<script>
  export default {

    props: {
      post: {
        type: Object,
        required: true
      }
    },

    computed: {

      postType () {
        switch (this.post.type) {
          case 'communique':
            return 'communiqué'
            break
          case 'etablissement':
            return 'établissement'
            break
          case 'temoignage':
            return 'témoignage'
            break
          case 'breve':
            return 'brève'
            break
          default:
            return this.post.type
        }
      },

      facebookShareUrl () {
        return 'https://www.facebook.com/sharer/sharer.php'
            + '?u=' + encodeURIComponent(this.post.link)
            + '&p[images][0]=' + encodeURIComponent(this.thumbnailUrl('facebook'))
            + '&p[title]=' + encodeURIComponent(this.post.title.rendered)
            + '&p[summary]=' + encodeURIComponent(this.resume())
      },

      twitterShareUrl () {
        return 'https://twitter.com/intent/tweet'
            + '?url=' + encodeURIComponent(this.post.link)
            + '&text=' + encodeURIComponent(_.truncate(this.post.title.rendered, { 'length': 80 }))
            + '&via=' + window.initialState.twitterVia
      },

      emailShareUrl () {
        let body = `A lire sur le site de l'OIP : \n\r ${this.resume()} \n\r ${this.post.link}`
        return 'mailto:'
            + '?subject=' + encodeURIComponent('[OIP] ' + _.truncate(this.post.title.rendered, { 'length': 80 }))
            + '&body=' + encodeURIComponent(body)
      },

      postClasses () {
        return {
          'entry': true,
          'horizontal-entry': true,
          ['entry-' + this.post.type]: true
        }
      },

      date () {
        return new Date(Date.parse(this.post.date_gmt))
          .toLocaleDateString('fr-FR', {
            year: "numeric",
            month: "long",
            day: "numeric"
          })
      },

      postUrl () {
        return '/' + this.post.type + '/' + this.post.slug
      },

      tags () {
        if (this.post.hasOwnProperty('_embedded')) {
          if (this.post._embedded.hasOwnProperty('wp:term')) {
            if (0 in this.post._embedded['wp:term']) {
              return this.post._embedded['wp:term'][0]
            }
          }
        }

        return []
      }

    },

    methods: {

      thumbnailUrl (size = 'horizontal-entry') {
        if (this.post.hasOwnProperty('_embedded')) {
          if (this.post._embedded.hasOwnProperty('wp:featuredmedia')) {
            if (0 in this.post._embedded['wp:featuredmedia']) {
              if ('media_details' in this.post._embedded['wp:featuredmedia'][0]) {
                if ('sizes' in this.post._embedded['wp:featuredmedia'][0].media_details) {
                  if (size in this.post._embedded['wp:featuredmedia'][0].media_details.sizes) {
                    if ('source_url' in this.post._embedded['wp:featuredmedia'][0].media_details.sizes[size]) {
                      return this.post._embedded['wp:featuredmedia'][0].media_details.sizes[size].source_url
                    }
                  } else if ('full' in this.post._embedded['wp:featuredmedia'][0].media_details.sizes) {
                    return this.post._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url
                  }
                }
              }
            }
          } else {
            return window.initialState.defaultThumbnails[this.post.type][size]
          }
        } else {
          return window.initialState.defaultThumbnails[this.post.type][size]
        }

        return null
      },

      resume (charLength = 300) {
        return _.truncate(this.post.resume, {
          'length': charLength,
          'separator': ' ',
          'omission': ' (...)'
        })
      }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/posts/PostEntry.vue